/**
 * @fileoverview gRPC-Web generated client stub for acompanha.products.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/products/v1/products.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.products = {};
proto.acompanha.products.v1 = require('./products_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.products.v1.ProductsServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.products.v1.ProductsServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.products.v1.ListProductsRequest,
 *   !proto.acompanha.products.v1.ListProductsResponse>}
 */
const methodDescriptor_ProductsService_ListProducts = new grpc.web.MethodDescriptor(
  '/acompanha.products.v1.ProductsService/ListProducts',
  grpc.web.MethodType.UNARY,
  proto.acompanha.products.v1.ListProductsRequest,
  proto.acompanha.products.v1.ListProductsResponse,
  /**
   * @param {!proto.acompanha.products.v1.ListProductsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.products.v1.ListProductsResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.products.v1.ListProductsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.products.v1.ListProductsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.products.v1.ListProductsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.products.v1.ProductsServiceClient.prototype.listProducts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.products.v1.ProductsService/ListProducts',
      request,
      metadata || {},
      methodDescriptor_ProductsService_ListProducts,
      callback);
};


/**
 * @param {!proto.acompanha.products.v1.ListProductsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.products.v1.ListProductsResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.products.v1.ProductsServicePromiseClient.prototype.listProducts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.products.v1.ProductsService/ListProducts',
      request,
      metadata || {},
      methodDescriptor_ProductsService_ListProducts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.products.v1.GetProductsSummaryRequest,
 *   !proto.acompanha.products.v1.GetProductsSummaryResponse>}
 */
const methodDescriptor_ProductsService_GetProductsSummary = new grpc.web.MethodDescriptor(
  '/acompanha.products.v1.ProductsService/GetProductsSummary',
  grpc.web.MethodType.UNARY,
  proto.acompanha.products.v1.GetProductsSummaryRequest,
  proto.acompanha.products.v1.GetProductsSummaryResponse,
  /**
   * @param {!proto.acompanha.products.v1.GetProductsSummaryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.products.v1.GetProductsSummaryResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.products.v1.GetProductsSummaryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.products.v1.GetProductsSummaryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.products.v1.GetProductsSummaryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.products.v1.ProductsServiceClient.prototype.getProductsSummary =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.products.v1.ProductsService/GetProductsSummary',
      request,
      metadata || {},
      methodDescriptor_ProductsService_GetProductsSummary,
      callback);
};


/**
 * @param {!proto.acompanha.products.v1.GetProductsSummaryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.products.v1.GetProductsSummaryResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.products.v1.ProductsServicePromiseClient.prototype.getProductsSummary =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.products.v1.ProductsService/GetProductsSummary',
      request,
      metadata || {},
      methodDescriptor_ProductsService_GetProductsSummary);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.products.v1.GetProductRequest,
 *   !proto.acompanha.products.v1.GetProductResponse>}
 */
const methodDescriptor_ProductsService_GetProduct = new grpc.web.MethodDescriptor(
  '/acompanha.products.v1.ProductsService/GetProduct',
  grpc.web.MethodType.UNARY,
  proto.acompanha.products.v1.GetProductRequest,
  proto.acompanha.products.v1.GetProductResponse,
  /**
   * @param {!proto.acompanha.products.v1.GetProductRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.products.v1.GetProductResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.products.v1.GetProductRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.products.v1.GetProductResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.products.v1.GetProductResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.products.v1.ProductsServiceClient.prototype.getProduct =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.products.v1.ProductsService/GetProduct',
      request,
      metadata || {},
      methodDescriptor_ProductsService_GetProduct,
      callback);
};


/**
 * @param {!proto.acompanha.products.v1.GetProductRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.products.v1.GetProductResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.products.v1.ProductsServicePromiseClient.prototype.getProduct =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.products.v1.ProductsService/GetProduct',
      request,
      metadata || {},
      methodDescriptor_ProductsService_GetProduct);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.products.v1.CreateProductRequest,
 *   !proto.acompanha.products.v1.CreateProductResponse>}
 */
const methodDescriptor_ProductsService_CreateProduct = new grpc.web.MethodDescriptor(
  '/acompanha.products.v1.ProductsService/CreateProduct',
  grpc.web.MethodType.UNARY,
  proto.acompanha.products.v1.CreateProductRequest,
  proto.acompanha.products.v1.CreateProductResponse,
  /**
   * @param {!proto.acompanha.products.v1.CreateProductRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.products.v1.CreateProductResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.products.v1.CreateProductRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.products.v1.CreateProductResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.products.v1.CreateProductResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.products.v1.ProductsServiceClient.prototype.createProduct =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.products.v1.ProductsService/CreateProduct',
      request,
      metadata || {},
      methodDescriptor_ProductsService_CreateProduct,
      callback);
};


/**
 * @param {!proto.acompanha.products.v1.CreateProductRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.products.v1.CreateProductResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.products.v1.ProductsServicePromiseClient.prototype.createProduct =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.products.v1.ProductsService/CreateProduct',
      request,
      metadata || {},
      methodDescriptor_ProductsService_CreateProduct);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.products.v1.UpdateProductRequest,
 *   !proto.acompanha.products.v1.UpdateProductResponse>}
 */
const methodDescriptor_ProductsService_UpdateProduct = new grpc.web.MethodDescriptor(
  '/acompanha.products.v1.ProductsService/UpdateProduct',
  grpc.web.MethodType.UNARY,
  proto.acompanha.products.v1.UpdateProductRequest,
  proto.acompanha.products.v1.UpdateProductResponse,
  /**
   * @param {!proto.acompanha.products.v1.UpdateProductRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.products.v1.UpdateProductResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.products.v1.UpdateProductRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.products.v1.UpdateProductResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.products.v1.UpdateProductResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.products.v1.ProductsServiceClient.prototype.updateProduct =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.products.v1.ProductsService/UpdateProduct',
      request,
      metadata || {},
      methodDescriptor_ProductsService_UpdateProduct,
      callback);
};


/**
 * @param {!proto.acompanha.products.v1.UpdateProductRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.products.v1.UpdateProductResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.products.v1.ProductsServicePromiseClient.prototype.updateProduct =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.products.v1.ProductsService/UpdateProduct',
      request,
      metadata || {},
      methodDescriptor_ProductsService_UpdateProduct);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.products.v1.AdjustProductStockRequest,
 *   !proto.acompanha.products.v1.AdjustProductStockResponse>}
 */
const methodDescriptor_ProductsService_AdjustProductStock = new grpc.web.MethodDescriptor(
  '/acompanha.products.v1.ProductsService/AdjustProductStock',
  grpc.web.MethodType.UNARY,
  proto.acompanha.products.v1.AdjustProductStockRequest,
  proto.acompanha.products.v1.AdjustProductStockResponse,
  /**
   * @param {!proto.acompanha.products.v1.AdjustProductStockRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.products.v1.AdjustProductStockResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.products.v1.AdjustProductStockRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.products.v1.AdjustProductStockResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.products.v1.AdjustProductStockResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.products.v1.ProductsServiceClient.prototype.adjustProductStock =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.products.v1.ProductsService/AdjustProductStock',
      request,
      metadata || {},
      methodDescriptor_ProductsService_AdjustProductStock,
      callback);
};


/**
 * @param {!proto.acompanha.products.v1.AdjustProductStockRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.products.v1.AdjustProductStockResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.products.v1.ProductsServicePromiseClient.prototype.adjustProductStock =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.products.v1.ProductsService/AdjustProductStock',
      request,
      metadata || {},
      methodDescriptor_ProductsService_AdjustProductStock);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.products.v1.DeleteProductRequest,
 *   !proto.acompanha.common.v1.DeleteResponse>}
 */
const methodDescriptor_ProductsService_DeleteProduct = new grpc.web.MethodDescriptor(
  '/acompanha.products.v1.ProductsService/DeleteProduct',
  grpc.web.MethodType.UNARY,
  proto.acompanha.products.v1.DeleteProductRequest,
  acompanha_common_v1_common_pb.DeleteResponse,
  /**
   * @param {!proto.acompanha.products.v1.DeleteProductRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.DeleteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.products.v1.DeleteProductRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.DeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.DeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.products.v1.ProductsServiceClient.prototype.deleteProduct =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.products.v1.ProductsService/DeleteProduct',
      request,
      metadata || {},
      methodDescriptor_ProductsService_DeleteProduct,
      callback);
};


/**
 * @param {!proto.acompanha.products.v1.DeleteProductRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.DeleteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.products.v1.ProductsServicePromiseClient.prototype.deleteProduct =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.products.v1.ProductsService/DeleteProduct',
      request,
      metadata || {},
      methodDescriptor_ProductsService_DeleteProduct);
};


module.exports = proto.acompanha.products.v1;

